import { render, staticRenderFns } from "./DisplayHeading.vue?vue&type=template&id=0394cce8&"
import script from "./DisplayHeading.vue?vue&type=script&lang=js&"
export * from "./DisplayHeading.vue?vue&type=script&lang=js&"
import style0 from "./DisplayHeading.vue?vue&type=style&index=0&id=0394cce8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports